import React from "react";
import Hero from "./Hero";
import Features from "./Features";
import PhotosVideosSlider from "./PhotosVideosSlider";
import Footer from "./Footer";
import DemoComponent from "./DemoComponent";
import "../css/LandingPage.css";
import TestimonialPage from "./TestimonialPage";
import StudentFeedback from "./StudentFeedback";
import OurImpact from "./OurImpact";

export default function LandingPage() {
  return (
    <div className="main-content">
      <Hero />
      <OurImpact />
      <Features />
      <TestimonialPage />
      <StudentFeedback />
      <PhotosVideosSlider />
      <DemoComponent />
      <Footer />
    </div>
  );
}
